import Vue from 'vue'

import VJsf from '@koumoul/vjsf/lib/VJsf'
import '@koumoul/vjsf/lib/VJsf.css'
import '@koumoul/vjsf/lib/deps/third-party'

Vue.component('VJsf', VJsf)
